import { logError } from '@ptek/client-logger';
import { useBrandTheme, useWidgetEvents } from '@ptek/widget-core';
import { useCallback, useContext } from 'react';
import { WIDGET_EVENTS } from '../../../constants/events';
import { AppContext } from '../../../context/AppContext';
import {
  CONSENT_ACTIONS,
  ConsentActionType,
  DIALOG_TYPES,
  useDialogStore,
} from '../../../stores/dialogStore';
import {
  loadUserSettingsPreferences,
  saveUserSettingsPreferences,
} from '../../../utils/userPreferences';

export const useConsentFlow = () => {
  const { user } = useContext(AppContext);
  const { emitToHost } = useWidgetEvents();
  const { openDialog } = useDialogStore();
  const brand = useBrandTheme();

  const checkPatientConsent = useCallback(async (): Promise<boolean> => {
    const userId = user?.username || user?.email;

    const preferences = loadUserSettingsPreferences(userId);
    if (preferences.patientConsent === true) {
      return true;
    }

    try {
      const result = await openDialog<{
        action: ConsentActionType;
        doNotShowAgain: boolean;
      }>(DIALOG_TYPES.PATIENT_CONSENT, {
        patientName: brand.brandName,
      });

      if (result.action === CONSENT_ACTIONS.CONSENT) {
        if (result.doNotShowAgain) {
          saveUserSettingsPreferences(userId, {
            ...preferences,
            patientConsent: true,
          });
        }
        return true;
      } else {
        emitToHost(WIDGET_EVENTS.EMITTER_NAMES.CONFIRM_CLOSE);
        return false;
      }
    } catch (error) {
      logError('useConsentFlow', 'Error showing consent dialog:', error);
      return false;
    }
  }, [user, openDialog, emitToHost, brand.brandName]);

  return { checkPatientConsent };
};
